jQuery(document).ready(function ($) {

    if ($('#user-role-selection').length) {
        $('.hero-image').removeClass('loading');
    }

    if ($('#user-role-selection-buttons').length) {
        $('.user-selection__wrapper').removeClass('loading');
    }

    $('#user-role-selection a, #user-role-selection-buttons a').on('click', function (e) {
        e.preventDefault();

        if (!$(this).hasClass('logged')) {
            const userType = $(this).hasClass('doctor') ? 'unr_vet' : 'owner';

            createCookie('user_type', userType, false);

            clearCart();
            onUnregisteredUserChange(userType);
        }
    });

    /**
     * @description Clear cart
     */
    function clearCart() {
        const ajaxUrl = wc_ajax_add_to_cart.ajax_url;
        const nonce = VetfondsJs.vetShopData.nonce;

        $.ajax({
            type: 'post',
            data: {},
            url: ajaxUrl + '?action=clearcart&none=' + nonce,
            beforeSend: function () {},
            complete: function () {},
            success: function () {},
        });
    }

    /**
     * @description Do a redirection after user type select
     * @param {string} userType
     */
    function onUnregisteredUserChange(userType) {
        const siteUrl = VetfondsJs.vetShopData.siteUrl;
        const restUrl = VetfondsJs.vetShopData.restApiUrlBase + 'change-user';
        const redirectUrl = readCookie('user_select_redirect');
        const decodedRedirectUrl = vetUrlDecode(redirectUrl);

        $('.spinner-main').addClass('loaded');

        $.ajax({
            type: 'post',
            data: { user_type: userType },
            url: siteUrl + restUrl,
            beforeSend: function () {},
            complete: function () {
                const id = Date.now();
                const newUrl = buildUserChangeRedirectUrl(decodedRedirectUrl, id);

                window.location.href = newUrl;
            },
            success: function () {},
        });
    }

    function buildUserChangeRedirectUrl(redirectUrl, id) {
        const targetUrl = getSafeRedirectUrl(redirectUrl);
        const separator = targetUrl.indexOf('?') !== -1 ? '&' : '?';

        return targetUrl + separator + 'user_change=true&id=' + id;
    }

    function getSafeRedirectUrl(redirectUrl) {
        const fallbackUrl = window.location.origin + window.location.pathname;

        if (!redirectUrl) {
            return fallbackUrl;
        }

        try {
            const parsedUrl = new URL(redirectUrl, window.location.origin);

            if (parsedUrl.origin !== window.location.origin) {
                return fallbackUrl;
            }

            return parsedUrl.origin + parsedUrl.pathname;
        } catch (e) {
            return fallbackUrl;
        }
    }

    function vetUrlDecode(url) {
        return url ? decodeURIComponent(url.replace(/\+/g, ' ')) : url;
    }

    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            var expires = "; expires=" + date.toGMTString();
        } else var expires = "";

        document.cookie = name + "=" + value + expires + "; path=/";
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];

            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }

            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }

        return null;
    }

    $('#user-role-selection').on('mouseenter', function () {
        if ($(this).hasClass('logged') && $(this).find('.tooltip').length > 0) {
            $(this).find('.tooltip').removeClass('hide');
        }
    }).on('mouseleave', function () {
        if ($(this).hasClass('logged') && $(this).find('.tooltip').length > 0) {
            $(this).find('.tooltip').addClass('hide');
        }
    });
});